
//  let domainName = "skeleton.bino.ro";

let domainName = "app.senecanticafe.ro";

export const config = {
    API_BASE_URL: "https://api." + domainName + "",
};
